import { useEffect } from 'react';
import { Typography } from '@mui/material';
import FulfillmentAssignmentRules from 'dashboard409a/components/FulfillmentAssignmentRules/FulfillmentAssignmentRules';
import { useCompanyDashboardContext } from 'dashboard409a/context/CompanyDashboardContext/CompanyDashboardContext';

const AssignmentRules = () => {
  const { updatePageActions } = useCompanyDashboardContext();

  useEffect(() => {
    if (updatePageActions) {
      updatePageActions(null);
    }
  }, [updatePageActions]);

  return (
    <>
      <Typography variant="h2" gutterBottom>
        Assignment Rules
      </Typography>
      <FulfillmentAssignmentRules />
    </>
  );
};

export default AssignmentRules;
